<template>
  <section class="documents-section">
    <div class="resources-container" v-if="loading">
      <div class="category-name">
        <div class="skeleton-box" style="width: 20%; height: 16px; border-radius: 10px;"></div>
      </div>
      <div class="documents-grid">
          <v-skeleton-loader elevation="2" class="card-loader document-card category-card" v-for="index in 4" :key="index"
                  type="heading, list-item, button"></v-skeleton-loader>
      </div>
    </div>
    <div class="resources-container" v-else>
      <div class="resource-group" v-for="(categories, groupName, index) in groupedCategories" :key="groupName">
        <h2>{{ groupName }}</h2>


        <div class="documents-grid">
          <div class="document-card" v-for="(category, index) in categories" :key="index">
            <div class="icon-title">
              <v-icon :class="category.url"></v-icon>
              <h3>{{ category.name }}</h3>
            </div>
            <p>{{ category.desc }}</p>
            <div class="button-container">
              <v-btn class="add-course-button" @click="goToResources(category.id, category.name)" outlined>
                Select
              </v-btn>
            </div>
          </div>
        </div>
        <div class="support-banner" v-if="index == 0 && !isPartner && !isAccountManager">
          <a :href="getRouteUrl('quickResources')">
            <!-- Desktop Image -->
            <v-img v-if="$vuetify.breakpoint.mdAndUp" :src="$globalConfig.APP_NAME === 'senso' ? '/static/resources/senso-learn-quick-start-banner-desktop.png' : '/static/resources/quick-start-thin-banner-desktop.png'"
              alt="quick start banner"></v-img>
            <!-- Tablet Image -->
            <v-img v-else-if="$vuetify.breakpoint.smAndUp && $vuetify.breakpoint.smAndDown"
              :src="$globalConfig.APP_NAME === 'senso' ? '/static/resources/senso-learn-quick-start-banner-tablet.png' : '/static/resources/quick-start-thin-banner-tablet.png'" alt="quick start banner"></v-img>
            <!-- Mobile Image -->
            <v-img v-else :src="$globalConfig.APP_NAME === 'senso' ? '/static/resources/senso-learn-quick-start-banner-mobile.png' : '/static/resources/quick-start-thin-banner-mobile.png'"
              alt="quick start banner"></v-img>
          </a>
        </div>
      </div>
      <div class="support-banner">
          <a
            :href="$globalConfig.APP_NAME === 'senso' ? 'mailto:learn@senso.cloud?subject=Customer%20Inquiry&body=Hello%20Senso%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20...' : 'mailto:support@improve.online?subject=Customer%20Inquiry&body=Hello%20Improve%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20...'">
            <!-- Desktop Image -->
            <v-img v-if="$vuetify.breakpoint.mdAndUp" :src="$globalConfig.APP_NAME === 'senso' ? '/static/resources/senso-help-and-support-banner-desktop.png' : '/static/resources/help-and-support-banner-desktop.png'"
              alt="help and support banner"></v-img>

            <!-- Tablet Image -->
            <v-img v-else-if="$vuetify.breakpoint.smAndUp && $vuetify.breakpoint.smAndDown"
              :src="$globalConfig.APP_NAME === 'senso' ? '/static/resources/senso-help-and-support-banner-tablet.png' : '/static/resources/help-and-support-banner-tablet.png'" alt="help and support banner"></v-img>

            <!-- Mobile Image -->
            <v-img v-else :src="$globalConfig.APP_NAME === 'senso' ? '/static/resources/senso-help-and-support-banner-mobile.png' : '/static/resources/help-and-support-banner-mobile.png'"
              alt="help and support banner"></v-img>
          </a>
        </div>
    </div>
  </section>
</template>

<script>
import userAPI from '@/api/user.js';

export default {
  name: 'ResourseCategory',
  data() {
    return {
      groupedCategories: [],
      loading: false,
      isPartner: this.$store.getters.partner,
      isAccountManager: this.$store.getters.accountManager
    }
  },
  mounted() {
    this.getAllResourceCategories();
  },
  methods: {
    getAllResourceCategories() {
      this.loading = true;
      userAPI
        .getResourceCategory()
        .then((resp) => {
          this.groupedCategories = resp.data.data;
          this.loading = false;
        });
    },
    goToResources(id) {
      this.$router.push('/resources/' + id);
    },
    getRouteUrl(routeName) {
      return this.$router.resolve({ name: routeName }).href;
    }
  }
}
</script>

<style scoped>

.document-card h3 {
  margin: 0;
}

.document-card i {
  font-size: 24px;
  margin-bottom: 10px;
}

.document-card p {
  color: #666;
  height: 35px;
}

.support-banner{
  margin-top: 40px;
}
</style>